import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl-next';

import { AtlassianSupportLink } from '@confluence/error-boundary';

export const CommentErrorFlag = ({ flags, errorTitle, errorMessage, onCloseFlag }) => {
	useEffect(() => {
		flags.showErrorFlag({
			onClose: onCloseFlag,
			title: <FormattedMessage {...errorTitle} />,
			description: (
				<FormattedMessage
					{...errorMessage}
					values={{ atlassianSupportLink: <AtlassianSupportLink /> }}
				/>
			),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};

CommentErrorFlag.propTypes = {
	flags: PropTypes.object.isRequired,
	errorTitle: PropTypes.object.isRequired,
	errorMessage: PropTypes.object.isRequired,
	onCloseFlag: PropTypes.func.isRequired,
	errorDetails: PropTypes.object.isRequired,
};
